var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailModal2Fa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2032_643)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 4.5C0.5 3.90326 0.737053 3.33097 1.15901 2.90901C1.58097 2.48705 2.15326 2.25 2.75 2.25H16.25C16.8467 2.25 17.419 2.48705 17.841 2.90901C18.2629 3.33097 18.5 3.90326 18.5 4.5V13.5C18.5 14.0967 18.2629 14.669 17.841 15.091C17.419 15.5129 16.8467 15.75 16.25 15.75H2.75C2.15326 15.75 1.58097 15.5129 1.15901 15.091C0.737053 14.669 0.5 14.0967 0.5 13.5V4.5ZM2.75 3.375C2.45163 3.375 2.16548 3.49353 1.9545 3.7045C1.74353 3.91548 1.625 4.20163 1.625 4.5V4.74412L9.5 9.46912L17.375 4.74412V4.5C17.375 4.20163 17.2565 3.91548 17.0455 3.7045C16.8345 3.49353 16.5484 3.375 16.25 3.375H2.75ZM17.375 6.05587L12.0222 9.26775L17.375 12.5033V6.057V6.05587ZM17.3368 13.7936L10.9299 9.9225L9.5 10.7809L8.069 9.9225L1.66325 13.7925C1.7276 14.0315 1.86895 14.2426 2.06542 14.3931C2.26189 14.5436 2.50251 14.6251 2.75 14.625H16.25C16.4973 14.6252 16.7378 14.5438 16.9343 14.3935C17.1307 14.2432 17.2722 14.0324 17.3368 13.7936ZM1.625 12.5033L6.97775 9.26775L1.625 6.05587V12.5021V12.5033Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2032_643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailModal2Fa);
export default __webpack_public_path__ + "static/media/emailModal2fa.9c18740433432a0f8a0e6565efe65e8d.svg";
export { ForwardRef as ReactComponent };